import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import {
    Box,
    Grid,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    Typography,
    MenuItem,
} from "@mui/material";
import styles from "../../../styles.module.css";
import sales_order from "../../../services/sales_order";
import { Breadcrumb, CTSinput, SearchInput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection"; // Adjusted import path
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const Distribution_Master = () => {
    const defaultRowsPerPage = useSelector((state) => state.sales_order?.rows_per_page || 15);
    const totalCount = useSelector((state) => state.pickup_entry?.total_count || 0);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage,
    });
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState("");
    const [successMessage, setSuccessMessage] = useState(null);

    const fields = ["customer_name"];
    const labels = ["Customer Name"];

    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await sales_order.getpendingSalesorder(params);
            const dataArray = Array.isArray(response) ? response : response.data || [response];
            setRows(dataArray.map((row) => ({ ...row })));
        } catch (error) {
            console.error("Error in fetchData:", error);
            setSuccessMessage("Error fetching data");
        }
    };

    const sortedRows = useMemo(() => {
        return [...rows].sort((a, b) => {
            const dateA = a.po_date ? new Date(a.po_date) : new Date();
            const dateB = b.po_date ? new Date(b.po_date) : new Date();
            return dateB - dateA;
        });
    }, [rows]);

     const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    const handleChangePage = (event, newPage) => {
        setController((prev) => ({ ...prev, page: newPage }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
    };

    const handleSearch = (e) => {
        setSearchKey(e.target.value);
        setController((prev) => ({ ...prev, page: 0 }));
    };

    useEffect(() => {
        fetchData();
    }, [controller, searchKey]);

    return (
        <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={styles.body}>
                <Breadcrumb routeSegments={[{ name: "Distribution Master List" }]} />

                <HeaderSection
                    title="Distribution Master List"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Distribution Master List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={0.6}>
                            <Grid item xs={10} sm={10}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", sm: "row" },
                                        alignItems: { xs: "stretch", sm: "center" },
                                    }}>
                                    <Typography className={styles.label_Txt}>Cylinder No</Typography>
                                    <CTSinput
                                        size="small"
                                        fullWidth
                                        name="cyl_no"
                                        InputProps={{ className: styles.CTSinput_Box }}
                                    />

                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper sx={{ width: "100%", overflow: "hidden" }}>
                            <TableContainer component={Paper} className={styles.list_tbl_container}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align="left" className={styles.table_head}>Cylinder No</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Customer Name</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Product Code</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Delivered On</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Issue Depot</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Vehicle No (Delivery)</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>DC No (Delivery)</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Invoice No (Delivery)</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Delivered By</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Empty Collection Date & Nos</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Receipt Depot</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Vehicle No (Collection)</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>DC No (Collection)</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Invoice No (Collection)</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Received By</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>CTR</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody sx={{backgroundColor:'#ffffff'}}>
                                        {Array.isArray(sortedRows) && sortedRows.length > 0 ? (
                                            sortedRows.map((row, index) => (
                                                <StyledTableRow key={row.sales_order_id || index}>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.cylinder_no || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.customer_name || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.prod_code || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.delivered_on || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.issue_depot || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.vehicle_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.dc_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.invoice_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.delivered_by || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.empty_collection_date || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.receipt_depot || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.vehicle_no_collection || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.dc_no_collection || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.invoice_no_collection || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.received_by || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.ctr || "-"}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={16} align="center">
                                                    No data available
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>

                <TablePagination
                    component="div"
                    onPageChange={handleChangePage}
                    page={controller.page}
                    count={effectiveTotalCount}
                    rowsPerPage={controller.rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={() => setSuccessMessage(null)}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default Distribution_Master;
